import { useCallback, useEffect, useState } from 'react';

import { getAlertTypes } from '../../api/services/Alerts';

type AlertTypeOption = { value: string; label: string };

import { reportError } from '../../utils/errorReporting/error';

interface IUseAlerts {
  alertTypeOptions?: AlertTypeOption[];
  loading: boolean;
}

export const useAlertTypes = (): IUseAlerts => {
  const [alertTypeOptions, setAlertTypeOptions] = useState<AlertTypeOption[]>();
  const [loading, setLoading] = useState(true);

  const fetchAlertTypes = useCallback(async () => {
    setLoading(true);

    try {
      const response = await getAlertTypes();

      if (response.type === 'success') {
        setAlertTypeOptions(response.data?.alertTypes || []);

        if (response.data?.alertTypes?.length === 0) {
          reportError(new Error('Alert types fetched successfully but the data array was empty'));
        }
      } else {
        reportError(new Error('Failed to fetch alert types: ' + response.error));
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAlertTypes();
  }, [fetchAlertTypes]);

  return {
    alertTypeOptions,
    loading,
  };
};
